export const BIOS = [
  {
    start: 1999,
    text: "Born in Skopje, Macedonia",
  },

  {
    start: 2014,
    end: 2018,
    text: "Completed high school at 'Orce Nikolov', Skopje, Macedonia",
  },

  {
    start: 2018,
    end: 2025,
    text: "Obtained a Bachelor's degree in Computer Science at 'Ss. Cyril and Methodius University', Skopje, Macedonia",
  },

  {
    start: 2021,
    end: 2026,
    text: "Worked as a software engineer at Endava",
  },

  {
    start: 2023,
    text: "Started contractual engineering services for the organization MindLeaps",
  },

  {
    start: 2026,
    text: "Started work as a software developer at Hornetsecurity",
  },
];
